export default __webpack_public_path__ + "static/media/1876.52ef51b2.jpg";